import { getCssVarDefine, getCssVarObject } from "../utils/makeCSSVariable";
import { SHADOWS_LIGHT, SHADOW_BORDERS_DARK, SHADOW_BORDERS_LIGHT, SHADOWS_DARK } from "./raw-value";

/* ================================ SHADOW ================================= */
var SHADOW_CSS_VARS_LIGHT = getCssVarDefine(SHADOWS_LIGHT, 'shadow');
var SHADOW_CSS_VARS_DARK = getCssVarDefine(SHADOWS_DARK, 'shadow');

/**
 * 阴影
 * 
 * 用法：box-shadow: ${SHADOWS.XS};
 */
export var SHADOWS = getCssVarObject(SHADOWS_LIGHT, 'shadow');
export var SHADOW_CSS_VARS = {
  light: SHADOW_CSS_VARS_LIGHT,
  dark: SHADOW_CSS_VARS_DARK
};

/* ================================ SHADOW BORDER ================================= */
var SHADOW_BORDER_CSS_VARS_LIGHT = getCssVarDefine(SHADOW_BORDERS_LIGHT, 'shadow_border');
var SHADOW_BORDER_CSS_VARS_DARK = getCssVarDefine(SHADOW_BORDERS_DARK, 'shadow_border');

/**
 * 阴影搭配的边框边框
 * 
 * 用法：border: ${SHADOW_BORDERS.XS};
 */
export var SHADOW_BORDERS = getCssVarObject(SHADOW_BORDERS_LIGHT, 'shadow_border');
export var SHADOW_BORDER_CSS_VARS = {
  light: SHADOW_BORDER_CSS_VARS_LIGHT,
  dark: SHADOW_BORDER_CSS_VARS_DARK
};

/* ================================ SHADOW STYLE ================================= */
/**
 * 阴影样式
 * 
 * 开箱即用的阴影样式，集成了阴影和其对应的边框
 * 
 * 使用时无需写前缀，直接将其作为样式即可
 * 
 * 用法：
 * ```tsx
 * const Demo = styled.div`
 *  width: xxx;
 *  ${CSS_SHADOW.XS}
 *  position: yyy;
 * `
 * ```
 */
export var CSS_SHADOWS = {
  XS: "box-shadow: " + SHADOWS.XS + "; border: " + SHADOW_BORDERS.XS + ";",
  S: "box-shadow: " + SHADOWS.S + ";",
  M: "box-shadow: " + SHADOWS.M + ";",
  L: "box-shadow: " + SHADOWS.L + ";",
  SELECTED: "box-shadow: " + SHADOWS.SELECTED + "; border: " + SHADOW_BORDERS.SELECTED + ";"
};